export const environment = {
  production: false,
  scopeUri: 'api://047e72ca-6ff6-4eb4-aee0-48261dda7eaa/Read',
  gatewayHost : 'https://nutritional-api-tst.publix.io/api/v1',
  tenantId: '623cac68-b5d0-45f1-9109-3122c3974cc9',
  ClienId: 'e87e8c5c-be65-4e3e-b5be-aff1277399f5',
  apiVersion:'v1'  
};